var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotes = function SvgNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.666.666H3.333A2.663 2.663 0 0 0 .679 3.333l-.013 24 5.333-5.334h18.667c1.467 0 2.667-1.2 2.667-2.666v-16c0-1.467-1.2-2.667-2.667-2.667m-16 16H5.999v-2.667h2.667zm0-4H5.999V9.999h2.667zm0-4H5.999V5.999h2.667zm9.333 8h-6.666v-2.667h6.666zm4-4H11.333V9.999h10.666zm0-4H11.333V5.999h10.666z"
  })));
};
export default SvgNotes;